import PropTypes from 'prop-types'
import { Switch, Route } from 'react-router-dom'
import { connect } from 'react-redux'

import Auth from '../Auth'
import Home from '../Home'
import Room from '../Room'
import HelpPage from '../HelpPage'
import Page404 from '../404'
import Header from 'src/components/Header'
import Footer from 'src/components/Footer'
import { WhiteLayout, PaddedContent } from 'src/common/styled'

const App = props => {
  const { user } = props

  return (
    <WhiteLayout>
      <Header user={user} />
      <Switch>
        {/* Auth sends anyone without a session to SSO, so the public page must never mount it.
            The outer Switch is the whole mechanism: first match wins and Auth stays untouched. */}
        <Route exact path={'/aiutosale'}>
          <PaddedContent>
            <HelpPage />
          </PaddedContent>
        </Route>
        <Route>
          <Auth>
            <PaddedContent>
              <Switch>
                <Route component={Home} exact path={'/'} />
                <Route component={Room} exact path={'/room/:id'} />
                <Route component={Page404} />
              </Switch>
            </PaddedContent>
          </Auth>
        </Route>
      </Switch>
      <Footer />
    </WhiteLayout>
  )
}
App.propTypes = {
  user: PropTypes.object
}

const mapStateToProps = state => ({
  user: state.user.current
})
export default connect(mapStateToProps)(App)
